



























import { defineComponent, reactive } from '@vue/composition-api'
import { useI18n } from 'vue-i18n-bridge'
import { useMyAccount } from '@/composable/repositories/useAccount'
import { useToasts } from '@/composable/useToasts'
import MyAccountInputs from '@/components/domains/auth/MyAccountInputs.vue'
import ResourceHeader from '@/components/layouts/dashboard/ResourceHeader.vue'
import ScrollableWrapper from '@/components/common/ScrollableWrapper.vue'

export default defineComponent({
  name: 'MyAccount',

  components: { ResourceHeader, MyAccountInputs, ScrollableWrapper },

  setup() {
    const { t } = useI18n()
    const { addSuccessToast, addErrorToast } = useToasts()

    const { myAccount: item, fetchMyAccount, updateMyAccount } = useMyAccount()

    const loading = reactive({
      get: false,
      update: false
    })

    if (!item.value) {
      loading.get = true
      fetchMyAccount()
        .catch(() => addErrorToast(t('Unable to fetch your account info')))
        .finally(() => (loading.get = false))
    }

    const submit = (): void => {
      if (!item.value) {
        return
      }

      loading.update = true
      //@ts-expect-error
      const { email, name, password, password_confirmation } = item.value
      const payload = { email, name, password, password_confirmation }
      updateMyAccount(payload)
        .then(() => addSuccessToast(t('Your account has been updated')))
        .catch(() => addSuccessToast(t('Unable to update your account')))
        .finally(() => (loading.update = false))
    }

    return {
      item,
      submit,
      loading
    }
  }
})
